import React from 'react'

import imageLoader from './i/preloader.gif'

import './Loader.scss'

const Loader = ({ text = null, customClass = 'loader' }) => (
    <div className={customClass}>
        <img src={imageLoader} alt="" />
        {text && <p>{text}</p>}
    </div>
)

export default Loader
